import React from 'react';
import { useSelector } from 'react-redux';

import type { EventPageTabEntities, RacePageTabEntities } from '@swf/core/analytics/sports';
import { select } from '@swf/core/store';
import { TabLinkMenu } from '@swf/sports/components';
import type { ClientMarketGroup } from '@swf/sports/types/marketGroups';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import TabContent from './components/TabContent/TabContent';

export interface SportsMarketWidgetUrlParams {
  eventTypeSlug: string;
  eventTypeId: string;
  competitionSlug: string;
  competitionId: string;
  eventSlug: string;
  eventId: string;
}

export interface SportsRacePageWidgetUrlParams {
  eventTypeSlug: string;
  eventTypeId: string;
  venueSlug: string;
  meetingId: string;
  raceId: string;
}

interface Props {
  groups: ClientMarketGroup[];
  routeValues: SportsMarketWidgetUrlParams | SportsRacePageWidgetUrlParams;
  marketGroupSlug?: string;
  entities?: EventPageTabEntities | RacePageTabEntities;
}

const MarketGroupTabs: React.FC<Props> = ({ groups, routeValues, marketGroupSlug, entities }) => {
  const locale = useSelector(select.locale.get);

  return (
    <TabLinkMenu>
      {groups.map(({ type, name, trackingName, slug }, i) => {
        const isActive = !marketGroupSlug ? () => i === 0 : () => slug === marketGroupSlug;
        const { eventTypeId } = routeValues;

        const alias = !isMeetingBasedEventTypeId(Number(eventTypeId))
          ? 'sportsEvent'
          : 'sportsAnimalRacingRace';

        return (
          <TabLinkMenu.Link
            key={name}
            alias={alias}
            values={{ ...routeValues, marketGroup: slug }}
            isActive={isActive}
            hash={slug}
            entities={entities}
            trackText={locale === 'en' ? name : trackingName}
          >
            <TabContent type={type} name={name} isActive={isActive} />
          </TabLinkMenu.Link>
        );
      })}
    </TabLinkMenu>
  );
};

export default MarketGroupTabs;
